<template>
  <div class="promotion-fee-detail">
    <real-name-auth-gate @authenticated="refreshAfterAuthenticated">
      <template slot-scope="{ authenticated }">
        <el-card v-if="authenticated" class="page-card" shadow="never">
        <el-tabs v-model="activeTab" class="fee-detail-tabs">
          <el-tab-pane label="推广费分配明细" name="feeDetail">
            <fee-detail ref="feeDetail"></fee-detail>
          </el-tab-pane>
          <el-tab-pane label="推广人统计" name="promoterStats">
            <promoter-stats ref="promoterStats"></promoter-stats>
          </el-tab-pane>
        </el-tabs>
        </el-card>
      </template>
    </real-name-auth-gate>
  </div>
</template>

<script>
import FeeDetail from './feeDetail'
import PromoterStats from './promoterStats'
import RealNameAuthGate from '../components/realNameAuthGate'

export default {
  name: 'promotionManage_promotionFeeDetail',
  components: {
    FeeDetail,
    PromoterStats,
    RealNameAuthGate
  },
  data () {
    return {
      activeTab: 'feeDetail'
    }
  },
  methods: {
    refreshAfterAuthenticated () {
      this.$nextTick(() => {
        const currentRef = this.activeTab === 'promoterStats' ? this.$refs.promoterStats : this.$refs.feeDetail
        if (currentRef && currentRef.refreshAfterAuthenticated) {
          currentRef.refreshAfterAuthenticated()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.promotion-fee-detail {
  width: 100%;
  min-width: 0;
  overflow-x: hidden;

  .page-card {
    min-width: 0;
    margin-top: 30px;
  }

  /deep/ .fee-detail-tabs {
    min-width: 0;
  }

  /deep/ .fee-detail-tabs > .el-tabs__header {
    margin: 0 0 15px;
  }
}
</style>
